import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { UpgradeModule } from "@angular/upgrade/static";
import { CodemirrorModule } from "@ctrl/ngx-codemirror";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { TranslateModule } from "@ngx-translate/core";
import { NgrxFormsModule } from "ngrx-forms";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { OrderModule } from "ngx-order-pipe";
import { CheckboxModule } from "primeng/checkbox";
import { DropdownModule } from "primeng/dropdown";
import { TableModule } from "primeng/table";
import { TabViewModule } from "primeng/tabview";
import { SafePipeModule } from "safe-pipe";
import { ContenteditableDirective } from "../core/content-editable/contenteditable.directive";
import { JobModule } from "../job/job.module";
import { LocationsService } from "../locations/state/locations.service";
import { MessagesModule } from "../messages/messages.module";
import { PreviewEditModelComponent } from "./preview-edit-model.component";
import { PreviewEditSourceComponent } from "./preview-edit-source.component";
import { PreviewEditTemplateMediaComponent } from "./preview-edit-template-media.component";
import { PreviewEditTemplateSendMessageComponent } from "./preview-edit-template-send-message.component";
import { PreviewEditTemplateTabsComponent } from "./preview-edit-template-tabs.component";
import { PreviewEditTemplateComponent } from "./preview-edit-template.component";
import { PreviewEditTemplateActions } from "./state/preview-edit-template.actions";
import { PreviewEditTemplateEffects } from "./state/preview-edit-template.effects";
import {
  PreviewTemplatesReducers,
  STORE_FEATURE_KEY_PREVIEW_TEMPLATE,
} from "./state/preview-edit-template.reducer";
import { PreviewEditTemplateSelectors } from "./state/preview-edit-template.selectors";
import { PreviewEditTemplateService } from "./state/preview-edit-template.service";
import { UserSelectors } from '../user/state/user.selectors';
import { FeatureFlagsModule } from '../feature-flag/feature-flag.module';

@NgModule({
  imports: [
    CommonModule,
    TabViewModule,
    DropdownModule,
    BrowserModule,
    UpgradeModule,
    FormsModule,
    NgrxFormsModule,
    ReactiveFormsModule,
    TooltipModule,
    TableModule,
    EffectsModule.forFeature([PreviewEditTemplateEffects]),
    SafePipeModule,
    CodemirrorModule,
    MessagesModule,
    CheckboxModule,
    NgxIntlTelInputModule,
    BrowserAnimationsModule,
    StoreModule.forFeature(
      STORE_FEATURE_KEY_PREVIEW_TEMPLATE,
      PreviewTemplatesReducers
    ),
    JobModule,
    OrderModule,
    TranslateModule,
    FeatureFlagsModule
  ],
  declarations: [
    PreviewEditTemplateTabsComponent,
    PreviewEditModelComponent,
    PreviewEditTemplateComponent,
    PreviewEditSourceComponent,
    PreviewEditTemplateMediaComponent,
    PreviewEditTemplateSendMessageComponent,
  ],
  providers: [
    PreviewEditTemplateService,
    PreviewEditTemplateActions,
    PreviewEditTemplateSelectors,
    ContenteditableDirective,
    LocationsService,
    UserSelectors
  ],
})
export class PreviewEditTemplatesModule {}
